export default [
    {
        path: '',
        name: 'recharge',
        meta: {
            title: '充值'
        },
        component: () => import('@/views/recharge/index.vue')
    },
    {
        path: 'payResult',
        name: 'rechargeResult',
        meta: {
            title: '支付'
        },
        component: () => import('@/views/recharge/payResult.vue')
    }
]
